import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import SiteFooter from "../components/SiteFooter";

export default function LegalLayout({ title, subtitle, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="min-h-screen bg-[#0a1626] flex flex-col">
      {/* Minimal header */}
      <header className="border-b border-white/10 bg-[#0a1626]/90 backdrop-blur-md">
        <div className="max-w-4xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/">
            <Logo />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-300 hover:text-[#F5941E] transition-colors"
          >
            <ArrowLeft size={16} />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      {/* Title */}
      <div className="border-b border-white/10 bg-[#0c1a2c]">
        <div className="max-w-4xl mx-auto px-6 py-14">
          <span className="text-xs font-bold tracking-[0.2em] text-[#F5941E]">
            LOOKING4
          </span>
          <h1 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-3 text-slate-400">{subtitle}</p>
          )}
        </div>
      </div>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-6 py-14">
          <div className="legal-content space-y-6 text-slate-300 leading-relaxed">
            {children}
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}

// Reusable styled blocks for legal content
export function H2({ children }) {
  return (
    <h2 className="font-display text-2xl font-bold text-white mt-10 first:mt-0">
      {children}
    </h2>
  );
}

export function H3({ children }) {
  return <h3 className="text-lg font-semibold text-[#F5941E] mt-6">{children}</h3>;
}

export function P({ children }) {
  return <p className="text-slate-300 leading-relaxed">{children}</p>;
}

export function UL({ children }) {
  return (
    <ul className="list-disc pl-6 space-y-2 text-slate-300 marker:text-[#F5941E]">
      {children}
    </ul>
  );
}

export function Field({ children }) {
  return (
    <span className="rounded bg-white/5 px-2 py-0.5 text-slate-400 italic">
      {children}
    </span>
  );
}
